import { render, staticRenderFns } from "./MultiplePhonePicker.vue?vue&type=template&id=dba33e3a&scoped=true"
import script from "./MultiplePhonePicker.vue?vue&type=script&lang=ts"
export * from "./MultiplePhonePicker.vue?vue&type=script&lang=ts"
import style0 from "./MultiplePhonePicker.vue?vue&type=style&index=0&id=dba33e3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba33e3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
